<script setup lang="ts">
import { computed } from 'vue'

import { capitalize } from '@/helpers/utils'
import type { DeviceType } from '@/stores/interfaces/Editor'
import { useEditorStore } from '@/stores/Editor'

import DesktopIcon from '@/components/icons/DesktopIcon.vue'
import TabletIcon from '@/components/icons/TabletIcon.vue'
import PhoneIcon from '@/components/icons/PhoneIcon.vue'

const icons = {
  PhoneIcon,
  TabletIcon,
  DesktopIcon,
}

const devices: DeviceType[] = ['desktop', 'tablet', 'phone']
const store = useEditorStore()

const currentIcon = computed(
  () => (type: string) => `${capitalize(type)}Icon` as keyof typeof icons,
)

const selectDevice = (device: DeviceType) => (store.activeDevice = device)
const isDeviceActive = (device: DeviceType) => store.activeDevice === device
</script>

<template>
  <div class="editor-device-select">
    <ul class="editor-device-list">
      <li
        v-for="(device, index) in devices"
        :key="index"
        class="editor-device-list-item"
        :class="{ active: isDeviceActive(device) }"
        @click="selectDevice(device)"
      >
        <component :is="icons[currentIcon(device)]" />
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.editor-device-list {
  list-style-type: none;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
}

.editor-device-list-item {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--lightest);
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 150ms ease-in-out;

  &.active {
    background-color: var(--ui-green);

    :deep(svg) {
      path {
        fill: var(--lightest);
      }
    }
  }
}
</style>
